import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

(function($) {
    'use strict';

    // Function to initialize cart note triggers
    function initCartNoteTriggers() {
        // Show reference fields that already have values
        $('.cart-item-note').each(function() {
            const $input = $(this);
            if ($input.val().trim() !== '') {
                const $wrapper = $input.closest('.cart-item-note-wrapper');
                const $trigger = $wrapper.siblings('.cart-item-note-trigger');

                $wrapper.css('display', 'flex');
                $trigger.hide();
            }
        });

        // Toggle reference field visibility when trigger is clicked
        // Unbind first to prevent duplicate handlers
        $('.cart-item-note-trigger').off('click').on('click', function() {
            const $trigger = $(this);
            const $wrapper = $trigger.siblings('.cart-item-note-wrapper');

            $wrapper.slideDown(200, function() {
                $(this).css('display', 'flex');
            });

            // Hide the trigger when reference field is shown
            $trigger.hide();
        });
    }

    // Variable for timeout needs to be accessible to the input handler function
    let timeoutId;

    // Function to initialize cart note input handlers
    function initCartNoteInputs() {
        // Unbind first to prevent duplicate handlers
        $('.cart-item-note').off('input').on('input', function() {
            const $input = $(this);
            const cartItemKey = $input.data('cart-item-key');
            const note = $input.val();

            // Clear any existing timeout
            clearTimeout(timeoutId);

            // Set new timeout for 500ms after user stops typing
            timeoutId = setTimeout(function() {
                // Show loading indicator
                $input.css('opacity', '0.5');

                // Send AJAX request
                $.ajax({
                    url: cartNotesData.ajaxUrl,
                    type: 'POST',
                    data: {
                        action: 'update_cart_note',
                        cart_item_key: cartItemKey,
                        note: note,
                        security: (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : ''
                    },
                    success: function(response) {
                        // Remove loading indicator
                        $input.css('opacity', '1');

                        if (!response.success) {
                            console.error('Error updating note:', response.data);
                        }
                    },
                    error: function(xhr, status, error) {
                        // Remove loading indicator
                        $input.css('opacity', '1');
                        console.error('AJAX error:', error);
                    }
                });
            }, 500); // Wait 500ms after user stops typing
        });
    }

    $(document).ready(function() {
        // Initialize cart note triggers and inputs
        initCartNoteTriggers();
        initCartNoteInputs();

        // Rebind handlers after cart updates
        $(document.body).on('updated_cart_totals removed_from_cart item_removed_from_classic_cart', function() {
            initCartNoteTriggers();
            initCartNoteInputs();
        });
    });
})(jQuery);

jQuery(function($) {
    function crossSellSlider() {
        const crossSellSliders = document.querySelectorAll('[data-cross-sell-slider]');

        crossSellSliders.forEach(sliderElement => {
            const slider = new Splide(sliderElement, {
                type: 'slide',
                perPage: 3,
                perMove: 3,
                pagination: false,
                arrows: false,
                gap: '2.4rem',
                breakpoints: {
                    1024: {
                        perPage: 2,
                        gap: '1.2rem',
                    },
                    768: {
                        perPage: 1,
                        gap: '1rem',
                    }
                }
            });

            slider.mount();

            const wrapper = sliderElement.closest('.c-cross-sell__wrapper');
            if (wrapper) {
                const prevArrow = wrapper.querySelector('.c-cross-sell__wrapper__header__controls__arrow:first-of-type');
                const nextArrow = wrapper.querySelector('.c-cross-sell__wrapper__header__controls__arrow:last-of-type');

                if (prevArrow) prevArrow.addEventListener('click', () => slider.go('<'));
                if (nextArrow) nextArrow.addEventListener('click', () => slider.go('>'));
            }
        });
    }

    function refreshCrossSell() {
        if (!$('#ajax-cross-sell').length) {
            return;
        }

        $.ajax({
            url: wc_cart_params.ajax_url,
            type: 'POST',
            data: {
                action: 'refresh_cross_sells',
                security: (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) ? decolegnoAjax.nonce : ''
            },
            beforeSend: function() {
                const ajaxCrossSell = $('#ajax-cross-sell');
                ajaxCrossSell.addClass('is-loading');
                ajaxCrossSell.html('<div class="loader"></div>');
            },
            success: function(response) {
                if (response.success) {
                    $('#ajax-cross-sell').html(response.data.html);
                    crossSellSlider();
                }
            },
            complete: function() {
                const ajaxCrossSell = $('#ajax-cross-sell');
                ajaxCrossSell.removeClass('is-loading');
                ajaxCrossSell.find('.loader').remove();
            }
        });
    }

    $(document.body).on('updated_cart_totals removed_from_cart item_removed_from_classic_cart', refreshCrossSell);

    $(document).ready(function() {
        refreshCrossSell();
    });
});
